import React from 'react';
import Client1 from '../assets/napsa.png';
import Client2 from '../assets/nrfa.png';
import zamra from '../assets/zamra.png';
import znbs from '../assets/znbs.png';
import smartzm from '../assets/logosz.png';
import wfp from '../assets/wfp.png';
import natbrew from '../assets/natbrew.png';
import moh from '../assets/log_moh.gif';
import nstc from '../assets/NSTC.png';
import iom from '../assets/iom.png';
import unhcr from '../assets/unhcr.png';
import hpcz from '../assets/HPCZ.jpg';
import nmc from '../assets/nmc.png';
import metro from '../assets/metro.png';

// Array of client logos
const clients = [
  { logoUrl: Client1, name: 'Client 1' },
  { logoUrl: Client2, name: 'Client 2' },
  { logoUrl: zamra, name: 'ZAMRA' },
  { logoUrl: znbs, name: 'ZNBS' },
  { logoUrl: smartzm, name: 'Smart Zambia' },
  { logoUrl: wfp, name: 'WFP' },
  { logoUrl: natbrew, name: 'Natbrew' },
  { logoUrl: moh, name: 'MOH' },
  { logoUrl: nstc, name: 'NSTC' },
  { logoUrl: iom, name: 'IOM' },
  { logoUrl: unhcr, name: 'UNHCR' },
  { logoUrl: hpcz, name: 'HPCZ' },
  { logoUrl: nmc, name: 'NMC' },
  { logoUrl: metro, name: 'Metro' },
];

// Individual client logo component with animation
const ClientLogo = ({ logoUrl, name }) => {
  return (
    <div className="flex justify-center items-center p-4 transition-transform transform hover:scale-110">
      <img
        className="h-16 md:h-20 lg:h-24 w-auto object-contain opacity-80 hover:opacity-100 transition-opacity duration-300 shadow-lg hover:shadow-xl"
        src={logoUrl}
        alt={`${name} Logo`}
      />
    </div>
  );
};

// Main ClientsPage component
const ClientsPage = () => {
  return (
    <div className="min-h-screen bg-gray-100 py-12 px-4 lg:px-24">
      <header className="bg-gradient-to-r from-[#023B8D] to-[#C5B358] text-white py-6 shadow-md">
        <h1 className="text-3xl font-bold text-center">Our Valued Customers</h1>
      </header>
      <main className="container mx-auto mt-8">
        <p className="text-center text-lg text-gray-600 mb-12">
          We are proud to collaborate with a diverse range of clients, helping them achieve their goals with our exceptional services.
        </p>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6 place-items-center">
          {clients.map((client, index) => (
            <ClientLogo key={index} logoUrl={client.logoUrl} name={client.name} />
          ))}
        </div>
      </main>
    </div>
  );
};

export default ClientsPage;
